import { parseItemKey } from "@plannello/shared";
import { createFileRoute, notFound } from "@tanstack/react-router";
import { ItemPage } from "@/components/items/ItemPage";

/** Canonical item URL: /NWS-12 (any case). Old keys redirect to the current one. */
export const Route = createFileRoute("/_app/$itemKey")({
  beforeLoad: ({ params }) => {
    if (!parseItemKey(params.itemKey)) throw notFound();
  },
  component: Item,
});

function Item() {
  const { itemKey } = Route.useParams();
  return <ItemPage itemKey={itemKey} />;
}
